import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { ChartsModule, SparklineModule } from '@progress/kendo-angular-charts';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { KPIService, ReportingService } from '@api-reports-client';
import { reportsServiceProvider } from '@app/shared/service-providers';
import { TooltipModule } from '@app/shared/components/ui';

// import { AuthGuard } from '../shared/guards/auth.guard';
import { SharedModule } from './../shared/shared.module';
import { HomeComponent } from './home/home.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

@NgModule({
  declarations: [HomeComponent, UnauthorizedComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      // { path: 'home', component: HomeComponent, canActivate: [AuthGuard] }
      // { path: 'home', redirectTo: '/dashboard' },
      { 
        path: 'dashboard',
        component: HomeComponent
      },
      // /welcome used to hold the page until the menu loaded (ZEY-2925); old links land on the launchpad.
      { path: 'welcome', redirectTo: '/', pathMatch: 'full' },
      { path: 'unauthorized', component: UnauthorizedComponent }
    ]),
    SharedModule,
    LayoutModule,
    ButtonsModule,
    GridModule,
    ChartsModule,
    SparklineModule,
    LoaderModule,

    TooltipModule
  ],
  providers: [...reportsServiceProvider([KPIService, ReportingService])]
})
export class CoreModule { }
